import React from 'react'
import { message } from 'antd'
import { RefStoredValue } from '../hooks/StoreHooks'
import * as con from "../Constants"
import { RefLanguage } from '../hooks/LanguageHooks'
import { setStoredValue } from '../store/actions'
import { CustomRunButton } from '../elements/CustomButtons'

/**
 * TestDataButton component
 */
export function TestDataButton() {
    const selectedDatabase = RefStoredValue(con.SELECTED_DATABASE)

    const i18n = RefLanguage()

    // Load test data based on the currently selected database
    const loadTestData = async () => {
        let filePath = '';

        // Determine which file to load based on selected database
        if (selectedDatabase === con.DATABASE_ITS) {
            filePath = '/data/test_data_ITS.fasta';
        } else if (selectedDatabase === con.DATABASE_SSU) {
            filePath = '/data/test_data_SSU.fasta';
        } else if (selectedDatabase === con.DATABASE_LSU) {
            filePath = '/data/test_data_LSU.fasta';
        } else if (selectedDatabase === con.DATABASE_LrRNA) {
            filePath = '/data/test_data_rRNA.fasta';
        }

        if (filePath) {
            try {
                const response = await fetch(filePath);
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const text = await response.text();
                setStoredValue(con.INPUT_TEXT_SEQUENCE, text);
                message.info(i18n.t("testDataLoaded"));
            } catch (error) {
                console.error("Error loading test data:", error);
                message.error(i18n.t("errorLoadingTestData"));
            }
        }
    }

    return (
        <div data-tour="test-data">
            <CustomRunButton
                onClick={loadTestData}
                width={"90%"}
            >
                {i18n.t("loadTestData")}
            </CustomRunButton>
        </div>
    )
}



